import { LMEUserSettings } from "@mcleod/general";
import { AutogenLayoutCRMMultiProfile } from "./autogen/AutogenLayoutCRMMultiProfile";
import { MultiProfilePlanningTabs } from "@mcleod/dispatch/src/planning/MultiProfilePlanningTabs";
import { PanelProps } from "@mcleod/components";

export class CRMMultiProfile extends AutogenLayoutCRMMultiProfile {
    private userProfiles: string[] = [];

    async onLoad(): Promise<void> {
        if (LMEUserSettings.get()?.call_list_profile != null)
            this.userProfiles.push(LMEUserSettings.get().call_list_profile);

        new MultiProfilePlanningTabs({
            tabset: this.tabsetCallListProfiles,
            profileDataSource: this.sourceCallListProfile,
            mainLayoutName: "lme/crm/CustomerRelationshipManager",
            advancedFilterLayout: "lme/crm/CallListProfileFilter",
            startingProfiles: this.userProfiles,
            profileDescrFieldName: "descr",
            refreshAfterTabChange: true
        });
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
